import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";

export default function EditRubricForm({ rubric, onSave, onCancel, loading, error }) {
  const [category, setCategory] = useState(rubric?.category || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ category: category.trim() || null });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 3, border: 1, borderColor: "grey.300", borderRadius: 1 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Edit Rubric
      </Typography>

      <TextField
        fullWidth
        label="Category"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        disabled={loading}
        error={!!error}
        helperText={error?.message}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
